module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hero', {
    attrs: {
      "content": _vm.heroContent
    },
    on: {
      "hamburger": _vm.hamburgerClicked
    }
  }), _vm._v(" "), _c('voters', {
    staticClass: "voters col-xs-12"
  }), _vm._v(" "), _c('slider-quote', {
    staticClass: "col-xs-12 no-pad",
    attrs: {
      "id": "bestEnsembleSlider1",
      "sliderContent": _vm.quoteSlider1
    }
  }), _vm._v(" "), _c('slider-image', {
    attrs: {
      "sliderContent": _vm.imageSlider1
    }
  }), _vm._v(" "), _c('click-thru', {
    attrs: {
      "clickThru": _vm.clickThru
    },
    on: {
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('social'), _vm._v(" "), _c('legal')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4aa889a0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aa889a0","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/categoryPages/BestEnsemble.vue
// module id = 403
// module chunks = 0